import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
  DvFormComponent,
  DvFormElement,
  DvFormUtil,
  DvTextInputElement,
  DvFormWrapperComponent,
} from '@devinco/ui/dds';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-custom-text-dialog',
  imports: [
    DvDialogContentComponent,
    DvButtonComponent,
    TranslatePipe,
    DvFormComponent,
    DvFormWrapperComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './custom-text-dialog.component.html',
})
export class CustomTextDialogComponent extends DvDialogContent {
  private translate = inject(TranslateService);
  elements: DvFormElement[] = [
    new DvTextInputElement({
      formControlParams: { key: 'text' },
      labelText: this.translate.instant('General.CustomLinkText'),
      colspan: 12,
    }),
  ];
  formGroup: FormGroup<{ text: FormControl<string> }> = DvFormUtil.buildFormGroup(this.elements);
}
